const liveEndpointPath = '/ytlapi/';
const mockEndpointPath = '/assets/mocks/';

const endpoints = {
  getCoastWatchAmenityLocations: createEndpoint(false, 'coastwatchamenitylocations/get', 'getCoastWatchBeachSpillLocations'),
  getCoastWatchAmenitySpillLocations: createEndpoint(false, 'coastwatchamenityspilllocations/get', 'getCoastWatchAmenitySpillLocations'),
  getCoastWatchBeachLocations: createEndpoint(false, 'coastwatchbeachlocations/get', 'getCoastWatchBeachLocations'),
  getCoastWatchBeachSpillLocations: createEndpoint(false, 'coastwatchbeachspilllocations/get', 'getCoastWatchBeachSpillLocations'),
  getPostcodeLookup: createEndpoint(false, 'postcodelookupapi/get', 'getPostcodeLookup'),
  getLocations: createEndpoint(false, 'locations/get', 'getCoastWatchLocations'),
  getLocationDetails: createEndpoint(false, 'locationdetails/get', 'getCoastWatchLocationDetails'),
  getCoastwatchLocationDetails: createEndpoint(false, 'coastwatchlocationdetails/get', 'getCoastWatchLocationDetails'),
  getSearchResultsDoc: createEndpoint(false, 'mediasearch/get', 'getSearchResultsDoc'),
  getSearchResultsPage: createEndpoint(false, 'search/get', 'getSearchResultsPage'),
  getWeatherDetails: createEndpoint(true, 'https://api.openweathermap.org/data/2.5/forecast/daily'),
  getResourcesResults: createEndpoint(false, 'resourcesresultsapi/get', 'getResourcesResults'),
  getCommunitySearchResults: createEndpoint(false, 'communitysearchapi/get', 'getCommunitySearchResults'),
  getCommunitySearchResultsPaged: createEndpoint(false, 'communitysearchapi/get', 'getCommunitySearchResultsPaged'),
  getProjectSearchResults: createEndpoint(false, 'projectsearchapi/get', 'getProjectSearchResults'),
  getIncidentDetails: createEndpoint(false, 'incidentdetails/get', 'getIncidentDetails'),
  getNoWaterLocations: createEndpoint(false, 'burstsandnowater/get', 'getNoWaterLocations'),
  getLeakReportedLocations: createEndpoint(false, 'leakreported/get', 'getLeakReportedLocations'),
  getSewerFloodLocations: createEndpoint(false, 'sewerfloods/get', 'getSewerFloodLocations'),
  getDiscolouredWaterLocations: createEndpoint(false, 'discolouredwater/get', 'getDiscolouredWaterLocations'),
  getPlannedInterruptionsLocations: createEndpoint(false, 'plannedinterruptions/get', 'getPlannedInterruptionsLocations'),
  getIncidentsBannerItems: createEndpoint(false, 'incidentsbanneritems/get', 'getIncidentsBannerItems'),
  getNetworkMaintenanceLocations: createEndpoint(false, 'networkmaintenance/get', 'getNetworkMaintenanceLocations'),
  getSewerageWorksLocations: createEndpoint(false, 'sewerageworks/get', 'getSewerageWorksLocations'),
  getContactDetails: createEndpoint(false, 'reportaproblemlocations/get', 'getContactDetails'),
  getStreetworkLocations: createEndpoint(false, 'streetworks/get', 'getStreetworkLocations'),
  getBoundaries: createEndpoint(false, 'boundaries/get', 'getBoundaries'),
  getChildPageCtas: createEndpoint(false, 'childpagectas/get', 'getChildPageCtas'),
  postIncidentReport: createEndpoint(false, 'reportaproblem/post', 'postIncidentReport'),
  postIncidentUpload: createEndpoint(false, 'reportaproblemfileuploadproxy/post', 'postIncidentUpload'),
  postResourcesResults: createEndpoint(false, 'resourcesresultsapi/post', 'postResourcesResults'),
  getDocumentLibrary: createEndpoint(false, 'documentlibrary/get', 'getDocumentLibrary'),
  getCardList: createEndpoint(false, 'cardList/get', 'getCardList'),
  postSearchEvent: createEndpoint(false, 'searchEvents/post', 'postSearchEvent'),
};

function createEndpoint(thirdParty, liveEndpoint, mockEndpoint) {
  if (thirdParty) {
    return liveEndpoint;
  }

  return (window.mockMode) ? `${mockEndpointPath}${mockEndpoint}.json` : `${liveEndpointPath}${liveEndpoint}`;
}

function lookupEndpoint(key) {
  return endpoints[key];
}

export default lookupEndpoint;


// WEBPACK FOOTER //
// ./src/scripts/mando.endpoints.js